import { Avatar, Icon, IconButton, ListItem, ListItemAvatar, ListItemIcon, ListItemSecondaryAction, ListItemText } from '@material-ui/core';
import { InsertDriveFile } from '@material-ui/icons';
import { PathHelper } from '@sensenet/client-utils';
import React from 'react';
import { renderIconDefault } from "../icon.js";

/**
 * Represents a default renderer for reference grid row
 */
export const DefaultItemTemplate = props => {
  const {
    content,
    repository
  } = props;

  const renderIcon = item => {
    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'User')) {
      var _item$Avatar, _item$DisplayName;

      const avatarUrl = (_item$Avatar = item.Avatar) === null || _item$Avatar === void 0 ? void 0 : _item$Avatar.Url;

      if (avatarUrl) {
        return /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
          alt: item.FullName,
          src: avatarUrl && repository !== null && repository !== void 0 && repository.configuration.repositoryUrl ? `${repository.configuration.repositoryUrl}${avatarUrl}` : ''
        }));
      }

      return /*#__PURE__*/React.createElement(ListItemAvatar, null, /*#__PURE__*/React.createElement(Avatar, {
        alt: item.DisplayName
      }, (_item$DisplayName = item.DisplayName) === null || _item$DisplayName === void 0 ? void 0 : _item$DisplayName.split(' ').map(namePart => namePart[0]).join('.')));
    }

    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'Image') && (!item.PageCount || item.PageCount <= 0)) {
      return /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement("img", {
        "data-test": "reference-selection-image",
        alt: item.DisplayName,
        src: `${repository === null || repository === void 0 ? void 0 : repository.configuration.repositoryUrl}${item.Path}`,
        style: {
          width: '3em',
          height: '3em',
          objectFit: 'scale-down'
        }
      }));
    }

    if (repository !== null && repository !== void 0 && repository.schemas.isContentFromType(item, 'Image') && item.PageCount && item.PageCount > 0) {
      return /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement("img", {
        "data-test": "reference-selection-image",
        alt: item.DisplayName,
        src: PathHelper.joinPaths(repository === null || repository === void 0 ? void 0 : repository.configuration.repositoryUrl, item.Path, '/Previews', item.Version, 'thumbnail1.png'),
        style: {
          width: '3em',
          height: '3em',
          objectFit: 'scale-down'
        }
      }));
    }

    return /*#__PURE__*/React.createElement(ListItemIcon, {
      style: {
        marginRight: 0
      }
    }, /*#__PURE__*/React.createElement(Icon, null, /*#__PURE__*/React.createElement(InsertDriveFile, null)));
  };

  return /*#__PURE__*/React.createElement(ListItem, {
    style: props.actionName === 'browse' ? {
      padding: 0
    } : undefined,
    key: content.Id,
    button: false
  }, content.Type ? renderIcon(content) : null, /*#__PURE__*/React.createElement(ListItemText, {
    primary: content.DisplayName,
    style: {
      textAlign: 'left',
      paddingRight: 15
    }
  }), props.actionName && props.actionName !== 'browse' && !props.readOnly ? /*#__PURE__*/React.createElement(ListItemSecondaryAction, null, content.Id > 0 ? /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      var _props$remove;

      return (_props$remove = props.remove) === null || _props$remove === void 0 ? void 0 : _props$remove.call(props, content.Id);
    }
  }, props.renderIcon ? props.renderIcon('remove_circle') : renderIconDefault('remove_circle')) : /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => props.add()
  }, props.renderIcon ? props.renderIcon(content.Id === -1 ? 'add_circle' : 'refresh') : renderIconDefault(content.Id === -1 ? 'add_circle' : 'refresh'))) : null);
};
//# sourceMappingURL=default-item-template.js.map